<mat-form-field>
  <mat-label>{{ "FILTERS.member" | translate }}</mat-label>
  <mat-select [ngModel]="value" (ngModelChange)="modelChange($event)" (selectionChange)="selectionChanged($event)">
    <mat-option *ngFor="let option of members$ | async" [value]="bindReviewer ? option: option.id">{{
      option.reviewer | propertyLocalized | async
      }}</mat-option>
  </mat-select>
</mat-form-field>
